import React from 'react';
import { enrichIQFeatures } from '../../mock/content';
import { Check } from 'lucide-react';
import Reveal from './Reveal';

const EnrichIQ = () => {
  return (
    <section id="enrich-iq" className="bg-brand-soft py-20 md:py-24">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-brand-blue text-[12px] font-bold tracking-[0.16em] uppercase mb-4">
            The platform behind it
          </p>
          <h2 className="text-navy font-black tracking-[-0.01em] leading-[1.12] text-[32px] sm:text-[40px] md:text-[46px]">
            Enrich IQ does the work your team would otherwise hire for
          </h2>
          <p className="mt-6 text-body-muted text-[16px] leading-[1.7]">
            Every campaign we run under your brand is powered by Enrich IQ, our proprietary lead management platform. It is how leads get verified in minutes instead of days — and how you scale campaigns without scaling your operations team.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {enrichIQFeatures.map((f, i) => (
            <Reveal
              key={f}
              delay={i * 100}
              className="flex items-center gap-3 rounded-2xl bg-white shadow-mk px-5 py-5 hover:shadow-mk-lg hover:-translate-y-1 transition-all duration-300"
            >
              <span className="h-9 w-9 rounded-xl bg-gradient-to-br from-brand-pink to-brand-pink/70 text-white flex items-center justify-center shrink-0 shadow-[0_4px_11px_0_rgba(233,30,99,0.35)]">
                <Check size={16} strokeWidth={3} />
              </span>
              <span className="text-navy text-[14.5px] font-bold">{f}</span>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://leadiqpro.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center h-11 px-7 rounded-md bg-brand-blue hover:bg-brand-blue-dark text-white text-[13px] font-bold uppercase tracking-[0.08em] shadow-mk-blue hover:shadow-mk-blue-hover hover:-translate-y-0.5 transition-all duration-300"
          >
            Explore Enrich IQ
          </a>
        </div>
      </div>
    </section>
  );
};

export default EnrichIQ;
